import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Real } from '../../core/models/real.model';
//import { BookingService } from '../../core/models/booking-service.model';
import { ProviderService } from '../../core/models/provider-service.model';

@Component({
  selector: 'app-payment-info-modal',
  templateUrl: './payment-info-modal.component.html',
  styleUrls: ['./payment-info-modal.component.scss'],
})
export class PaymentInfoModalComponent implements OnInit {

  @Input() real: Real;
  @Input() service: ProviderService;

  noShowProtection = false;
  fullPaymentProtection = false;
  minSpendPaymentProtection = false;
  minSpendAmountPerPerson: number = 10;
  maxAmountPerPerson: number = 20;

  cancellationPeriodInHours: number = 48;
  cancellationPeriodInHoursForGroups: number = 48;

  constructor( private router: Router, private modalCtrl: ModalController, public translateService: TranslateService ) { }

  ngOnInit() {

    if ( this.service ) { //for events

      if ( this.service.cancellationPeriod ) {
        this.cancellationPeriodInHours = Math.floor(this.service.cancellationPeriod / 60);
      }

      if ( this.service.cancellationPeriodForGroups ) {
        this.cancellationPeriodInHoursForGroups = Math.floor(this.service.cancellationPeriodForGroups / 60);
      }

      if ( this.service.noShowProtection ) {
        this.noShowProtection = true;
        this.maxAmountPerPerson = this.service.noShowMaxPenaltyPerPerson ? this.service.noShowMaxPenaltyPerPerson: 20;
      }

      if ( this.service.paymentRequired ) {
        this.fullPaymentProtection = true;
        this.noShowProtection = false;
      }

      if ( this.service.minSpendRequired ) {
        this.minSpendPaymentProtection = true;
        this.noShowProtection = false;
        this.fullPaymentProtection = false;
        this.minSpendAmountPerPerson = this.service.minSpendAmount ? this.service.minSpendAmount: 10;
      }

    } else { //for default slots

      if ( this.real.cancellationPeriod ) {
        this.cancellationPeriodInHours = Math.ceil(this.real.cancellationPeriod / 60);
      }

      if ( this.real.cancellationPeriodForGroups ) {
        this.cancellationPeriodInHoursForGroups = Math.ceil(this.real.cancellationPeriodForGroups / 60);
      }
      
      if ( this.real.noShowProtection ) {
        this.noShowProtection = true;
        this.maxAmountPerPerson = this.real.noShowMaxPenaltyPerPerson ? this.real.noShowMaxPenaltyPerPerson: 20;
      }

      if ( this.real.paymentRequired ) {
        this.fullPaymentProtection = true;
        this.noShowProtection = false;
      }

      if ( this.real.minSpendRequired ) {
        this.minSpendPaymentProtection = true;
        this.noShowProtection = false;
        this.fullPaymentProtection = false;
        this.minSpendAmountPerPerson = this.real.minSpendAmount ? this.real.minSpendAmount: 10;
      }

    }

    console.log(this.minSpendPaymentProtection);
    console.log(this.noShowProtection);
    console.log(this.fullPaymentProtection);
    console.log(this.minSpendAmountPerPerson);
    console.log(this.cancellationPeriodInHours);
    console.log(this.cancellationPeriodInHoursForGroups);

    
    
  }

  onCancel() {
    this.modalCtrl.dismiss( null, 'cancel' );
  }

}
